import React, { useState, useEffect } from 'react';
import PaymentSteps from '../PaymentSteps/PaymentSteps';

import PaymentStepsOne from '../PaymentSteps/PaymentStepsOne';
import PaymentStepsSI from '../PaymentSteps/PaymentStepsSI';
import { Grid } from '@mui/material';
import PaymnetTabs from '../PaymentTabs/PaymnetTabs';
import PaymentDetails from './Components/CommonDetails/PaymentDetails';
import PlanAccordion from './Components/CommonDetails/PlanAccordion';
import PaymentAccordion from '../PaymentTabs/Components/PaymentAccordion';
import PaymentError from '../PaymentSteps/PaymentError';
import EmandateRegistered from '../PaymentSteps/EmandateRegistered';
import CustomizedDialogs from '../../Shared/CustomDialogs';
import SkipAutoPay from '../../Shared/SkipAutoPay';


function PaymnetView({apiData}) {

   const[isMobileView, setIsMobileView] = useState(false);
   const[callbackFailureUrl, setCallbackFailureUrl] = useState('');
   const [showSkipAutoPay, setShowSkipAutoPay] = useState(false);
   const [categoryValue, setCategoryValue] = useState(0);

   const handleCategoryValueChange = (newCategoryValue) => {
    console.log("Category Value changed to:", newCategoryValue);
    setCategoryValue(newCategoryValue); // You can update your parent state with the new value
  };



    useEffect(() => {
        const handleResize = () => {
            setIsMobileView(window.innerWidth <= 820);
        };
	handleResize();
	window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);


     const handleClick = () => {
        window.location.href =callbackFailureUrl;
      };

      useEffect(() => {
          if (apiData) {
              const callbackFailureUrl = apiData.callbackFailureUrl;
              setCallbackFailureUrl(callbackFailureUrl);
             }
      }, [apiData]);


    const certifiedLogosStyle = {
      fontSize: '12px',
      color: '#0065FF',	
      overflow: 'hidden',
      display: 'flex',
      justifyContent: 'space-between', // Align items to the edges
      alignItems: 'center', // Vertically center items
      padding: '10px',
      
    };

return (
    <>
        <div className='mt-1 paymnet-mode md:mt-10'>

        {apiData.isBackButtonVisible && (
           <div className="back-btn" style = {{marginBottom : '5px'}}>
                <button onClick={handleClick}>&lt; Back</button>
           </div>
        )}

            <ul className='payment-list-main'>
            <li className='sm:block lg:block lg:w-5/1 mr-8 align-top col-left-panel'>
                <>
                    {!apiData.isSI && <PaymentStepsOne/>}
                    {apiData.isSI && <PaymentStepsSI/>}
                </>
                   
                   {apiData.retry && <PaymentError retry = {apiData.retry}/>} 
                   {apiData.emandateRegistered  && <EmandateRegistered />}
                    <div className='hidden md:block mt-6 bg-slate-100 debit-card-tab'>
                        {!isMobileView && <PaymnetTabs onCategoryValueChange={handleCategoryValueChange}/>}
                        
                           <div className='block sm:hidden '>
                             {/* {isMobileView && <PlanAccordion />} */}
                            </div>
                       
                    </div>
                     {!isMobileView && (
                      <div style={certifiedLogosStyle} className="certified-logos hideSmall">
                          <p className="left">
                            <a href="https://www.policybazaar.com/legal-and-admin-policies/" target="_blank" rel="noopener noreferrer">
                              Privacy Policy
                            </a>
                            {'  |  '}
                            <a href="https://www.policybazaar.com/legal-and-admin-policies/#termsofuse" target="_blank" rel="noopener noreferrer">
                              Terms & Conditions
                            </a>
                            {'  |  '}
                            <a href="https://payment.policybazaar.com/pay/faq.jsp" target="_blank" rel="noopener noreferrer">
                              FAQ
                            </a>
                          </p>
                          <p className="right rightOne">
                            <a href="https://www.5tattva.com/verify/ftzdkix4sq" target="_blank" rel="noopener noreferrer">
                          
                              <img
                                src="./images/pci-dss-certified@2x.png"
                                alt="PCI DSS Certified"
                                width="84"
                              />
                            </a>
                          </p>
                    </div>
            )}
                </li>
                <li className='w-full  md:full lg:inline-block lg:w-2/5 col-right-panel'>
                    {!isMobileView &&  <PlanAccordion categoryValue = {categoryValue}/>}
                    
                  {apiData.isSkipAutoRegister &&( <button  onClick={() => setShowSkipAutoPay(true)} className='skip-autopay-btn'>Skip Autopay Registration</button>)}
                </li>
		<li className='block sm:block lg:hidden mobile-tabs'>
                 {isMobileView &&  <PaymentAccordion isSI={apiData.isSI} onCategoryValueChange={handleCategoryValueChange} /> }
                </li>
            </ul>
        </div>
       
     {showSkipAutoPay ? <CustomizedDialogs  className='razor-pay-dialog'  open={showSkipAutoPay} handleClose={() => setShowSkipAutoPay(false)}>
        <SkipAutoPay  handleCloseDialog={() => setShowSkipAutoPay(false)}/>
      </CustomizedDialogs>
      : null}
    </>
);
}

export default PaymnetView;

